import { Group, Text } from '@mantine/core'
import { IconCircleFilled } from '@tabler/icons-react'
import { FormattedMessage } from 'react-intl'

type OnlineStatusCountProps = {
  onlineCount?: number
  offlineCount?: number
}

export const OnlineStatusCount = ({
  onlineCount = 0,
  offlineCount = 0
}: OnlineStatusCountProps) => {
  return (
    <Group gap="xs">
      {onlineCount > 0 && (
        <Group gap={4} wrap="nowrap">
          <IconCircleFilled size={9} color="var(--mantine-color-green-6)" />

          <Text size="xs" style={{ whiteSpace: 'nowrap' }}>
            {onlineCount} <FormattedMessage id="devices.status.online" />
          </Text>
        </Group>
      )}

      {offlineCount > 0 && (
        <Group gap={4} wrap="nowrap">
          <IconCircleFilled size={9} color="var(--mantine-color-red-6)" />

          <Text size="xs" style={{ whiteSpace: 'nowrap' }}>
            {offlineCount} <FormattedMessage id="devices.status.offline" />
          </Text>
        </Group>
      )}
    </Group>
  )
}
